import axios from 'axios';
import { LoginCredentials, User, NewUser } from '../types/auth';

const API_URL = '/api';

// Save token to localStorage
const setToken = (token: string) => {
  localStorage.setItem('token', token);
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// Remove token from localStorage
const removeToken = () => {
  localStorage.removeItem('token');
  delete axios.defaults.headers.common['Authorization'];
};

// Initialize token from localStorage
const initializeToken = () => {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return token;
  }
  return null;
};

// Login user
const login = async (credentials: LoginCredentials) => {
  const response = await axios.post<{ user: User; token: string }>(`${API_URL}/auth/login`, credentials);
  const { token, user } = response.data;
  setToken(token);
  return { user, token };
};

// Get current user
const getCurrentUser = async () => {
  const response = await axios.get<{ user: User }>(`${API_URL}/auth/me`);
  return response.data.user;
};

// Logout user
const logout = () => {
  removeToken();
};

// Get all users (admin only)
const getAllUsers = async () => {
  const response = await axios.get<{ users: User[] }>(`${API_URL}/users`);
  return response.data.users;
};

// Create new user (admin only)
const createUser = async (userData: NewUser) => {
  const response = await axios.post<{ user: User }>(`${API_URL}/users`, userData);
  return response.data.user;
};

// Update user (admin only)
const updateUser = async (id: string, userData: Partial<NewUser>) => {
  const response = await axios.put<{ success: boolean }>(`${API_URL}/users/${id}`, userData);
  return response.data.success;
};

// Delete user (admin only)
const deleteUser = async (id: string) => {
  const response = await axios.delete<{ success: boolean }>(`${API_URL}/users/${id}`);
  return response.data.success;
};

export const authService = {
  login,
  logout,
  getCurrentUser,
  getAllUsers,
  createUser,
  updateUser,
  deleteUser,
  initializeToken
};